const router = function (permissions) {
  return ({
    path: 'cdv/atendimento',
    component: () => import('@/views/Atendimento/AtendimentoList.vue'),
    meta: { permissions, title: 'Movimentação do Atendimento' },
    props: (route) => ({ status: route.query.status }),
  })
}

export default {
  router,
}
